import { render, staticRenderFns } from "./BoxIndicadoresWorkflow.vue?vue&type=template&id=0df9b03e&scoped=true&"
import script from "./BoxIndicadoresWorkflow.vue?vue&type=script&lang=js&"
export * from "./BoxIndicadoresWorkflow.vue?vue&type=script&lang=js&"
import style0 from "./BoxIndicadoresWorkflow.vue?vue&type=style&index=0&id=0df9b03e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df9b03e",
  null
  
)

export default component.exports